import api from './api';

export const invoiceValidationService = {
  validateInvoice: async (data) => {
    try {
      const response = await api.post('/finance/invoices/validate', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getValidationQueue: async (params = {}) => {
    try {
      const response = await api.get('/finance/invoices/queue', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateValidationStatus: async (validationId, status) => {
    try {
      const response = await api.put(`/finance/invoices/queue/${validationId}`, { status });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getValidationAnalytics: async () => {
    try {
      const response = await api.get('/finance/invoices/analytics');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getValidationSettings: async () => {
    try {
      const response = await api.get('/finance/invoices/settings');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateValidationSettings: async (data) => {
    try {
      const response = await api.put('/finance/invoices/settings', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};
